import { action, observable } from 'mobx';

export const STORE_SIDE_STATE_NAME = 'kdev_left_side_state';
export enum sideState {
    close = 'close',
    open = 'open'
}
export const sideStateMap = {
    [sideState.close]: true,
    [sideState.open]: false
};

function restoreCollapseState() {
    const val = localStorage.getItem(STORE_SIDE_STATE_NAME);
    return val ? sideStateMap[val] : sideStateMap[sideState.open];
}

/**
 * 左侧导航的收起和展开状态，存一个全局store，方便修改
 */
export class MenuCollapsedStore {
    @observable public collapsed: boolean = restoreCollapseState() || false;

    private handleStorageCollapsed?: (collapsed: boolean) => void;

    // 外面如果要有自己的逻辑，需要先定义一下
    public setHandleStorageCollapsed(handleStorageCollapsed) {
        this.handleStorageCollapsed = handleStorageCollapsed;
    }

    @action.bound
    public setDefaultValue(collapsed) {
        this.collapsed = collapsed;
    }

    @action
    public changeCollapsed(collapsed) {
        this.collapsed = collapsed;
        if (this.handleStorageCollapsed) { // 如果外部传来了自己的处理逻辑，那就用外面的，没有就用默认的
            this.handleStorageCollapsed?.(collapsed);
            return;
        }
        localStorage.setItem(STORE_SIDE_STATE_NAME, collapsed ? sideState.close : sideState.open);
    }
}

export const menuCollapsedStore = new MenuCollapsedStore();